import { PermissionType } from './enum/PERMISSION';

export class UserClient {
  username: string;
  role: string;
  permissions: Array<PermissionType>;

  constructor(username: string, role: string, permissions: Array<PermissionType>) {
    this.username = username;
    this.role = role;
    this.permissions = permissions;
  }
}
